<template>
    <nav class="navbar" data-bs-theme="light">
        <div class="container-fluid">
            <div class="row row-cols-sm-1">
                <span class="col-sm-6" style="width: auto;">
                    <h4>ポケモン ステータス計算機 for SV</h4>
                </span>
                <span class="col-sm-6" style="width: auto;">
                    <h4>【素早さ自動調整機能付き】</h4>
                </span>
            </div>
        </div>
    </nav>
</template>

<style scoped>
.navbar {
    background-color: #ffa534;
    color: white;
}
</style>